const enTranslation = {
  // ===== FinancialModel 国际化 =====
  "FinancialModel.analysisSuffix": " - Financial Analysis",
  "FinancialModel.efficiencyAnalysis.coreStaffAnnualSalary":
    "Core Staff Annual Salary",
  "FinancialModel.efficiencyAnalysis.maAnnualSalary": "Mr. Ma Annual Salary",
  "FinancialModel.efficiencyAnalysis.liaoAnnualSalary":
    "Mr. Liao Annual Salary",
  "FinancialModel.efficiencyAnalysis.totalAnnualLaborCost":
    "Total Annual Labor Cost",
  "FinancialModel.efficiencyAnalysis.totalProjects": "Total Projects",
  "FinancialModel.efficiencyAnalysis.activeProjects": "Active Projects",
  "FinancialModel.efficiencyAnalysis.blockedProjects": "Blocked Projects",
  "FinancialModel.efficiencyAnalysis.completedProjects": "Completed Projects",
  "FinancialModel.efficiencyAnalysis.analysisDescriptionTitle":
    "Project Analysis Description",
  "FinancialModel.efficiencyAnalysis.analysisDescription":
    "{{totalProjects}} project tasks, Mr. Ma and Mr. Liao each have a monthly base salary of 10,000 yuan. The project analysis considers personnel participation, task priority, and project completion, providing data support for project management decisions.",
  "FinancialModel.efficiencyAnalysis.corePersonnelSalaryTitle":
    "Core Personnel Annual Salary",
  "FinancialModel.efficiencyAnalysis.personMaSalary": "Mr. Ma Annual Salary:",
  "FinancialModel.efficiencyAnalysis.personLiaoSalary":
    "Mr. Liao Annual Salary:",
  "FinancialModel.efficiencyAnalysis.totalLaborCost":
    "Total Annual Labor Cost:",
  "FinancialModel.efficiencyAnalysis.projectParticipationAnalysis":
    "Project Participation Analysis",
  "FinancialModel.efficiencyAnalysis.allTime": "All Time",
  "FinancialModel.efficiencyAnalysis.taskStatus": "Task Status",
  "FinancialModel.efficiencyAnalysis.participation": "Participation",
  "FinancialModel.efficiencyAnalysis.completionRate": "Completion Rate",
  "FinancialModel.monthlyAnalysis.monthlyExpenseTrend": "Monthly Expense Trend",
  "FinancialModel.monthlyAnalysis.expenseAnalysisMethodology":
    "Monthly Expense Analysis Methodology",
  "FinancialModel.monthlyAnalysis.methodologyBaseCost":
    "• Base Cost: Fixed salary for staff (Mr. Ma, Mr. Liao, each 10,000/month)",
  "FinancialModel.monthlyAnalysis.methodologyProjectExpense":
    "• Project Expense: Calculated based on the number of active projects",
  "FinancialModel.monthlyAnalysis.methodologyExpenseCategory":
    "• Expense Categories: Two main types - labor cost and project expense",
  "FinancialModel.monthlyAnalysis.keyMetricsDescription":
    "Key Metrics Description",
  "FinancialModel.monthlyAnalysis.metricTotalExpense":
    "• Total Monthly Expense = Labor Cost + Project Expense",
  "FinancialModel.monthlyAnalysis.metricLaborCost":
    "• Labor Cost: Fixed monthly salary + project performance (if applicable)",
  "FinancialModel.monthlyAnalysis.metricProjectExpense":
    "• Project Expense: Each active project budget 2,000 yuan",
  "FinancialModel.monthlyAnalysis.metricExpenseEfficiency":
    "• Expense Efficiency = Project Completion Rate / Total Expense",
  "FinancialModel.costStructure.cost_cloud": "Cloud Services & Software",
  "FinancialModel.costStructure.cost_labor": "Labor Cost",
  "FinancialModel.costStructure.cost_marketing": "Marketing & Sales",
  "FinancialModel.costStructure.cost_misc": "Miscellaneous & Reserve",
  "FinancialModel.costStructure.cost_material": "R&D Materials & Equipment",
  "FinancialModel.costStructure.cost_admin": "Administration & Compliance",
  "FinancialModel.costStructure.pieTitle":
    "Cost Structure Analysis (Based on Actual Reimbursement Data)",
  "FinancialModel.costStructure.detailTitle":
    "Cost Details (Based on Actual Reimbursement Data)",
  "FinancialModel.costStructure.total":
    "Total Cost (Accumulated Reimbursement)",
  "FinancialModel.costStructure.recordTitle": "Detailed Reimbursement Records",
  "FinancialModel.costStructure.table.category": "Category",
  "FinancialModel.costStructure.table.desc": "Description",
  "FinancialModel.costStructure.table.amount": "Amount",
  "FinancialModel.costStructure.人力成本": "Labor Cost",
  "FinancialModel.costStructure.研发材料设备": "R&D Materials & Equipment",
  "FinancialModel.costStructure.云服务软件": "Cloud Services & Software",
  "FinancialModel.costStructure.市场与销售": "Marketing & Sales",
  "FinancialModel.costStructure.行政与合规": "Administration & Compliance",
  "FinancialModel.costStructure.杂项预备金": "Miscellaneous & Reserve",
  "FinancialModel.expenseForecast.section1Title": "1. Runway Trend (Months)",
  "FinancialModel.expenseForecast.methodTitle": "Forecast Method:",
  "FinancialModel.expenseForecast.methodFormula":
    "Runway = Current Cash Balance ÷ Monthly Total Expense.",
  "FinancialModel.expenseForecast.baseCaseDesc":
    ": Assume expenses remain at current trend;",
  "FinancialModel.expenseForecast.bestCaseDesc":
    ": Expenses decrease by 5% per quarter;",
  "FinancialModel.expenseForecast.worstCaseDesc":
    ": Expenses increase by 5% per quarter.",
  "FinancialModel.expenseForecast.section1Explain":
    "Runway (months of cash sustainability) indicates how many months a company can continue to operate at the current cash reserve and spending rate. This trend chart shows the runway changes under different scenarios (base, optimistic, conservative) for the coming year, helping management assess the safety margin and decision space.",
  "FinancialModel.expenseForecast.baseCase": "Base Case",
  "FinancialModel.expenseForecast.baseCaseExplain":
    ": Assume income and expenses follow the current trend, runway gradually shortens, pay attention to cash flow health.",
  "FinancialModel.expenseForecast.bestCase": "Best Case",
  "FinancialModel.expenseForecast.bestCaseExplain":
    ": Income increases, costs optimized, runway extends, risk resistance improves.",
  "FinancialModel.expenseForecast.worstCase": "Worst Case",
  "FinancialModel.expenseForecast.worstCaseExplain":
    ": Income stagnates or costs rise, runway shortens sharply, early warning and countermeasures needed.",
  "FinancialModel.expenseForecast.scenarioForecastTitle":
    "Scenario Forecast - Runway Trend (Months)",
  "FinancialModel.expenseForecast.yAxisFormatter":
    "{{v}} months (sustainable operation months)",
  "FinancialModel.expenseForecast.healthyLabel":
    "Healthy: Funds can support over 12 months",
  "FinancialModel.expenseForecast.alertLabel":
    "Alert: Funds can support less than 6 months",
  "FinancialModel.expenseForecast.noticeLabel":
    "Notice: Funds can support 6-12 months",
  "FinancialModel.expenseForecast.section2Title": "2. Driver Forecast",
  "FinancialModel.expenseForecast.laborCost": "Labor Cost",
  "FinancialModel.expenseForecast.laborCostFormula":
    "Number of Employees × Average Salary",
  "FinancialModel.expenseForecast.laborCostCurrent":
    "Current: 2 × ¥10,000 = ¥20,000/month",
  "FinancialModel.expenseForecast.materialCost": "Material Cost",
  "FinancialModel.expenseForecast.materialCostFormula":
    "R&D Staff × Avg. Material Cost",
  "FinancialModel.expenseForecast.materialCostCurrent":
    "Current: 2 × ¥3,000 = ¥6,000/month",
  "FinancialModel.expenseForecast.cloudCost": "Cloud Service Cost",
  "FinancialModel.expenseForecast.cloudCostFormula":
    "Active Users × Per User Cost",
  "FinancialModel.expenseForecast.cloudCostCurrent":
    "Estimated: 100 users × ¥30 = ¥3,000/month",
  "FinancialModel.expenseForecast.driverForecastTrend":
    "Driver Forecast - Cost Trend",
  "FinancialModel.expenseForecast.section3Title": "3. Scenario Forecast",
  "FinancialModel.expenseForecast.baseCaseSituation": "Base Case (Baseline)",
  "FinancialModel.expenseForecast.baseCaseIncome": "• Income increases by 10%",
  "FinancialModel.expenseForecast.baseCaseMarket":
    "• Marketing expenses remain unchanged",
  "FinancialModel.expenseForecast.baseCaseRunway": '{">"} Runway: 18 months',
  "FinancialModel.expenseForecast.bestCaseSituation": "Best Case (Optimistic)",
  "FinancialModel.expenseForecast.bestCaseIncome": "• Income increases by 20%",
  "FinancialModel.expenseForecast.bestCaseHardware":
    "• Bulk procurement, hardware cost -10%",
  "FinancialModel.expenseForecast.bestCaseRunway": '{">"} Runway: 24 months',
  "FinancialModel.expenseForecast.worstCaseSituation":
    "Worst Case (Conservative)",
  "FinancialModel.expenseForecast.worstCaseIncome": "• No income growth",
  "FinancialModel.expenseForecast.worstCaseChip": "• Chip price +20%",
  "FinancialModel.expenseForecast.worstCaseRunway": '{">"} Runway: 12 months',
  "FinancialModel.expenseForecast.unitEconomicsTrend": "Unit Economics Trend",
  "FinancialModel.expenseForecast.section4Title": "4. Unit Economics Analysis",
  "FinancialModel.expenseForecast.cac": "Customer Acquisition Cost (CAC)",
  "FinancialModel.expenseForecast.cacFormula":
    "Total Marketing Expense ÷ New Users",
  "FinancialModel.expenseForecast.ltv": "Lifetime Value (LTV)",
  "FinancialModel.expenseForecast.ltvFormula":
    "Gross Profit per Unit × Lifetime (months)",
  "FinancialModel.expenseForecast.unitEconomicsRatio": "Unit Economics Ratio",
  "FinancialModel.expenseForecast.unitEconomicsRatioExplain":
    'LTV/CAC {">"} 3 means the model is healthy',
  "FinancialModel.expenseForecast.sensitivityAnalysisTitle":
    "Sensitivity Analysis - Impact of Cost Changes on Runway (Months)",
  "FinancialModel.loading": "Loading...",
  "FinancialModel.error": "Error",
  "FinancialModel.tab.monthlyAnalysis": "Monthly Analysis",
  "FinancialModel.tab.expenseForecast": "Expense Forecast",
  "FinancialModel.tab.costStructure": "Cost Structure",
  "FinancialModel.tab.efficiencyAnalysis": "Efficiency Analysis",
  "FinancialModel.pageTitle": "LUKKEY Project Analysis",
  "FinancialModel.fundStatusAnalysis": "Fund Status Analysis",
  "FinancialModel.status.warning": "Warning",
  "FinancialModel.status.healthy": "Healthy",
  "FinancialModel.status.notice": "Notice",
  "FinancialModel.status.alert": "Alert",
  "FinancialModel.fundSupportDuration": "Fund Support Duration",
  "FinancialModel.month": "months",
  "FinancialModel.warningLine": "Warning Line",
  "FinancialModel.avgMonthlyExpense": "Average Monthly Expense",
  "FinancialModel.basedOnLast3Months": "Based on the last 3 months average",
  "FinancialModel.remainingFunds": "Remaining Funds",
  "FinancialModel.initialFunds": "Initial Funds",
  "FinancialModel.currency.chf": "CHF",
  "FinancialModel.fundSupportOver12Months": "Funds can support over 12 months",
  "FinancialModel.fundSupport6to12Months": "Funds can support 6-12 months",
  "FinancialModel.fundSupportLess6Months":
    "Funds can support less than 6 months",
  "FinancialModel.avgMonthlyExpenseCalc": "Average Monthly Expense Calculation",
  "FinancialModel.considerExpenseTrend":
    "Consider expense growth trend for forecast",
  "FinancialModel.forecastLimit": "Forecast period limit",
  "FinancialModel.dataUpdateTime": "Data Update Time",
  // ===== MarketView i18n =====
  // ===== MarketView i18n =====
  "MarketView.title": "Market Dashboard",
  "MarketView.loading": "Loading...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "This tab failed to render",
  "MarketView.unknownError": "Unknown error",
  // ===== Common i18n =====
  "Common.refresh": "Refresh",
  "Common.toggleSeriesVisibility": "Toggle this series",
  "Common.error": "Error",
  "Common.dataUpdateTime": "Data Update Time",
  "Common.loading": "Loading...",
  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "Download backend data/youtube_stats.json",
  "YouTubeTab.downloadJson": "Download youtube_stats.json",
  "YouTubeTab.loading": "Loading YouTube metrics...",
  "YouTubeTab.errorHint":
    "If API key is not configured, set YOUTUBE_API_KEY or GOOGLE_API_KEY in backend/.env and restart the backend.",
  "YouTubeTab.header.totalViews": "Total Views (Multi-channel, Unit: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "Total Subscribers (Multi-channel, Unit: 10k)",
  "YouTubeTab.dist.views": "Views Distribution (10k)",
  "YouTubeTab.dist.subscribers": "Subscribers Distribution (10k)",
  "YouTubeTab.card.location": "Location:",
  "YouTubeTab.card.registeredAt": "Registered at:",
  "YouTubeTab.card.currentSubscribers": "Current Subscribers",
  "YouTubeTab.card.currentVideos": "Current Video Count",
  "YouTubeTab.card.currentTotalViews": "Current Total Views",
  "YouTubeTab.card.currentTotalComments": "Current Total Comments",
  "YouTubeTab.chart.totalSubscribers": "Total Subscribers",
  "YouTubeTab.chart.totalViews": "Total Views",
  "YouTubeTab.chart.totalComments": "Total Comments",
  "YouTubeTab.chart.totalVideos": "Total Videos",
  // ===== XTab i18n =====
  "XTab.downloadTitle": "Download backend data/x_stats.json",
  "XTab.downloadJson": "Download x_stats.json",
  "XTab.loading": "Loading X metrics...",
  "XTab.errorHint":
    "If Token is not configured, set X_BEARER_TOKEN or TWITTER_BEARER_TOKEN in backend/.env and restart the backend.",
  "XTab.header.totalFollowers": "Total Followers (Multi-channel, Unit: 10k)",
  "XTab.header.totalEngagement":
    "Total Engagement (last 5 posts: Likes + Retweets + Replies + Quotes, Unit: 10k)",
  "XTab.dist.followers": "Followers Distribution (10k)",
  "XTab.dist.engagement":
    "Engagement Distribution (last 5 posts: Likes + Retweets + Replies + Quotes, Unit: 10k)",
  "XTab.card.currentFollowers": "Current Followers",
  "XTab.card.currentFollowing": "Current Following",
  "XTab.card.currentTweets": "Current Tweet Count",
  "XTab.card.recentLikes": "Recent Likes (last 5 posts)",
  "XTab.card.recentRetweets": "Recent Retweets (last 5 posts)",
  "XTab.card.recentReplies": "Recent Replies (last 5 posts)",
  "XTab.card.recentQuotes": "Recent Views (content-level, last 5 posts)",
  "XTab.card.listed": "Listed Count (channel-level)",
  "XTab.smallChart.followers": "Followers",
  "XTab.smallChart.tweets": "Tweets",
  "XTab.smallChart.likes": "Recent Likes",
  "XTab.smallChart.retweets": "Recent Retweets",
  "XTab.smallChart.replies": "Recent Replies",
  "XTab.smallChart.quotes": "Recent Views (content-level)",
  "XTab.smallChart.following": "Following",
  "XTab.smallChart.listed": "Listed",
  "Common.noDataSource": "No data (data source not provided)",
  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "Filter by created month:",
  "Analytics.dashboardTitle": "Project Health Dashboard",
  "Analytics.metric.completionRate": "Completion Rate",
  "Analytics.metric.teamVelocity": "Team Velocity",
  "Analytics.metric.blockerRatio": "Blocker Ratio",
  "Analytics.metric.workloadBalance": "Workload Balance",
  "Analytics.charts.statusDistribution": "Status Distribution",
  "Analytics.charts.statusByMonthPercent": "Status by Month (Percentage)",
  "Analytics.charts.priorityDistribution": "Priority Distribution",
  "Analytics.charts.priorityByMonthPercent": "Priority by Month (Percentage)",
  "Analytics.charts.functionTypeDistribution": "Function Type Distribution",
  "Analytics.charts.functionTypeByMonthPercent":
    "Function Type by Month (Percentage)",
  "Analytics.blocker.ownerPie": "Blocked Issues · Owner Distribution (Donut)",
  "Analytics.blocker.ownerByMonth":
    "Blocked Issues · Owner by Month (Percentage)",
  "Analytics.bug.ownerPie": "Bug Issues · Owner Distribution (Donut)",
  "Analytics.bug.ownerByMonth": "Bug Issues · Owner by Month (Percentage)",
  "Analytics.charts.ownerByMonthCount": "Owner by Month (Counts, Stacked)",
  "Analytics.ownerWorkloadDistribution": "Team Workload Distribution",
  "Analytics.select.owners": "Select Owners:",
  "Analytics.mode.priority": "Priority Distribution",
  "Analytics.mode.status": "Status Distribution",
  "Analytics.mode.type": "Type Distribution",
  "Analytics.blocker.attentionNeeded": "Issues Requiring Immediate Attention",
  "Analytics.common.status": "Status",
  "Analytics.common.owner": "Owner",
  "Analytics.insights.sectionTitle": "Project Insights & Suggestions",
  "Analytics.insights.efficiency.title": "Efficiency Improvement Suggestions",
  "Analytics.insights.efficiency.completionRate":
    "• Current completion rate is {{rate}}%, keep an eye on blockers",
  "Analytics.insights.efficiency.avgVelocity":
    "• Team average velocity is {{velocity}} tasks/person",
  "Analytics.insights.efficiency.workloadBalance":
    "• Workload balance is {{balance}}%",
  "Analytics.insights.risk.title": "Risk Alerts",
  "Analytics.insights.risk.blockerRatio": "• Blocker ratio {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• P0 issues ratio {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• Prioritize high priority issues first",
  // ===== Common ranges =====
  "Common.to": "to",
  "Common.clear": "Clear",
  "Common.range.thisMonth": "This Month",
  "Common.range.lastMonth": "Last Month",
  "Common.range.last2": "Last 2 Months",
  "Common.range.last3": "Last 3 Months",
  "Common.range.last6": "Last 6 Months",
  "Common.range.thisYear": "This Year",
  "Common.range.all": "All",
  "Common.range.custom": "Custom",
  "Common.showFilters": "Show Filters",
  "Common.hideFilters": "Hide Filters",
  "Common.search": "Search",
  "Common.priority": "Priority",
  "Common.owner": "Owner",
  "Common.collaborator": "Collaborator",
  "Common.updatedAt": "Updated",
  // ===== Kanban i18n =====
  "Kanban.title": "Kanban View",
  "Kanban.totalIssues": "Total {{count}} issues",
  "Kanban.searchPlaceholder":
    "Search title, issue number, owner or collaborators...",
  "Kanban.status.backlog": "Backlog",
  "Kanban.status.inProgress": "In Progress",
  "Kanban.status.blocked": "Blocked / Pending Confirmation",
  "Kanban.status.reviewTest": "Review / Test",
  "Kanban.status.docs": "Docs",
  // ===== List i18n =====
  "List.title": "Issue List",
  "List.totalIssues": "Total {{count}} issues",
  "List.viewDetails": "View Details",
  "List.openInNewWindow": "Open in new window",
  "List.empty.title": "No issues",
  "List.empty.subtitle": "Create the first issue to start your workflow",
  // ===== Assets Register i18n =====
  "Assets.title": "Assets Register",
  "Assets.totalSets": "Total Sets",
  "Assets.table.employee": "Employee",
  "Assets.table.setCount": "Sets",
  "Assets.table.screen": "Screen",
  "Assets.table.model": "Model",
  "Assets.total": "Total",
  "Assets.production.title": "Production Devices Register",
  "Assets.production.totalUnits": "Total Production Units",
  "Assets.production.table.sn": "Device ID",
  "Assets.production.table.owner": "Holder / Destination",
  "Assets.production.table.status": "Status",
  "Assets.production.table.note": "Note",
  "Assets.production.total": "Total",
  "Assets.people.screenIcVendor": "Display IC Vendor",
  "Assets.people.stVendor": "ST Vendor",
  "Assets.models.gen3EalPcb": "Gen 3 EAL PCB",
  "Assets.models.gen3Pcb": "Gen 3 PCB",
  "Assets.models.gen3PcbDamagedBluetooth":
    "Gen 3 PCB damaged (Bluetooth flashing unavailable)",
  "Assets.models.gen3AssembledBlackUnit":
    "Gen 3 assembled PCB (black full unit)",
  "Assets.models.gen3PcbDamagedSerial":
    "Gen 3 PCB damaged (serial port failure)",
  "Assets.production.models.black": "Black",
  "Assets.production.models.silver": "Silver",
  "Assets.production.models.champagneGold": "Champagne Gold",
  "Assets.production.models.blackKeystonePrototype":
    "Black (Keystone prototype)",
  "Assets.production.models.blackHardwareUnoptimized":
    "Black (hardware not optimized)",
  "Assets.production.models.shellless": "Shell-less",
  "Assets.production.models.shelllessBroken": "Shell-less (broken)",
  "Assets.production.models.silverHeldByLijiaqi":
    "Silver (held by Li Jiaqi)",
  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "Project Issue Tracking",
  "LukkeyIssues.goToDemo": "Go to Demo Page",
  "LukkeyIssues.githubProject": "GitHub Project ↗",
  "LukkeyIssues.githubManageIssues": "Manage Issues directly on GitHub ↗",
  "LukkeyIssues.financeModel": "Finance Model",
  "LukkeyIssues.productCoreIssues": "Product Core Issues",
  "LukkeyIssues.stats.totalIssues": "📊 Total Issues",
  "LukkeyIssues.stats.completed": "✅ Completed",
  "LukkeyIssues.stats.inProgress": "🔄 In Progress",
  "LukkeyIssues.stats.pending": "⏳ Pending",
  "LukkeyIssues.stats.blocked": "🚫 Blocked",
  "LukkeyIssues.stats.docs": "📚 Docs",
  "LukkeyIssues.tabs.kanban": "Kanban View",
  "LukkeyIssues.tabs.analytics": "Analytics",
  "LukkeyIssues.tabs.market": "Market Dashboard",
  "LukkeyIssues.tabs.assets": "Assets Register",
  "LukkeyIssues.shareToChatGPT": "Open LUKKEY.json with ChatGPT",
  // ===== 其它原有翻译 =====

  Product: "Product",
  "Header.productNav": "LUKKEY Product",
  Feature: "Feature",
  "About Us": "About Us",
  FAQ: "FAQ",
  "Privacy Policy": "Privacy Policy",
  "Help Center": "Help Center",
  "Header.infoMenu": "More",
  "Header.appNow": "Get The App",
  "Header.appModal.title": "Use the LUKKEY app now",
  "Header.appModal.subtitle": "Choose your platform to get the official LUKKEY mobile app.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "Install the official app for iPhone.",
  "Header.appModal.iosButton": "Open",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Get the official Android app on Google Play.",
  "Header.appModal.googlePlayButton": "Open",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "Download the latest official APK directly.",
  "Header.appModal.androidButton": "Download",
  "Header.appModal.note": "Official mobile downloads only. Use the links above for the latest version.",
  "Academy": "Academy",
  "Legal": "Legal",
  "AboutUs.title": "About LUKKEY",
  "AboutUs.lede": "LUKKEY is a Swiss hardware wallet brand dedicated to building the highest standard of security for digital asset ownership.",
  "AboutUs.vision.closing": "Your keys. Your assets. Your future.",
  "AboutUs.quote": "LUKKEY builds the secure layer between people and digital assets.",
  "AboutUs.block1": "LUKKEY is based in Switzerland. It focuses on hardware wallets designed for secure self-custody.",
  "AboutUs.block2": "Its products combine secure elements, anti-tamper protection, and fully offline architecture. The goal is to keep private keys in an isolated environment.",
  "AboutUs.block3": "The system is designed without Wi-Fi, USB, or direct network dependence. Fingerprint access, NFC backup tools, and broad asset support keep the product practical in daily use.",
  "AboutUs.block5": "LUKKEY follows an open and auditable approach for core firmware and software. Security claims should remain inspectable and verifiable.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "Support Request",
  "WarrantySupport.intro": "Please fill in the information below to submit your support request.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "Issue Summary",
  "WarrantySupport.form.issueTitle.placeholder": "Enter a short summary",
  "WarrantySupport.form.warrantyType.label": "Request Type",
  "WarrantySupport.form.warrantyType.placeholder": "Select Request Type",
  "WarrantySupport.form.warrantyType.product": "Device Issue",
  "WarrantySupport.form.warrantyType.service": "App/Account Issue",
  "WarrantySupport.form.warrantyType.replacement": "Other",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "Describe the issue or request in detail",
  "WarrantySupport.form.submit": "Submit Support Request",
  "WarrantySupport.alert.success": "Your support request has been submitted!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "Help Center",
  "HelpCenter.intro":
    "Welcome to the LUKKEY Help Center, the official support and documentation hub for LUKKEY hardware wallets. Here you'll find product guides, setup instructions, and troubleshooting resources.",
  "HelpCenter.section4.title": "Need additional assistance?",
  "HelpCenter.section4.intro":
    "Save time by starting your support request online, and we'll connect you with a specialist. For your security, official support will never ask for your recovery phrase or private key:",
  "HelpCenter.contact.hint":
    "Use the button to submit a support request and we'll follow up by email.",
  "HelpCenter.cta.warranty": "Send a support request",
  "Footer.contact.email": "Email: info@lukkey.com",
  "Footer.contact.address":
    "Lukkey AG Global HQ, Dammstrasse 16, 6300 Zug, Switzerland",
  brandName: "LUKKEY", // 新增字段
  tagline: "Manage Your Crypto like never before", // 新增字段
  description:
    "LUKKEY keeps your private keys offline with hardware-first protection, so you can store and manage crypto with more control and less risk.", // 新增字段  learnMore: "Learn more",
  "Lock Your Crypto, Securely": "Lock Your Crypto, Securely",
  Testimonials: "Testimonials",
  Testimonial1:
    "I've been using this cold wallet for months now, and I'm impressed by its reliability and security features. Highly recommended!",
  Testimonial2:
    "This cold wallet exceeded my expectations! Its user-friendly interface and top-notch security make it a must-have for anyone serious about crypto.",
  Testimonial3:
    "I've tried several cold wallets before, but this one stands out. Its sleek design and advanced features make managing my crypto assets a breeze.",
  "John Doe": "John Doe",
  "Cryptocurrency Enthusiast": "Cryptocurrency Enthusiast",
  "Jane Smith": "Jane Smith",
  "Crypto Security Advocate": "Crypto Security Advocate",
  "Alex Johnson": "Alex Johnson",
  "Investment Analyst": "Investment Analyst",
  "Touchscreen Interface": "Touchscreen Interface",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.",
  "Bluetooth Connectivity": "Bluetooth Connectivity",
  "Wireless syncing with your devices for real-time updates.":
    "Wireless syncing with your devices for real-time updates.",
  "Airtag Tracking": "Airtag Tracking",
  "Track your wallet easily with built-in Airtag.":
    "Track your wallet easily with built-in Airtag.",
  "home.secureChip.title": "EAL6+ Secure Chip Technology",
  "home.secureChip.description":
    "Equipped with an EAL6+ secure chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.",
  "home.multiAccount.title": "3 Wallets in One Lukkey",
  "home.multiAccount.description":
    "Three separate wallets on one device, each with its own recovery phrase.",
  "Secure Chip Technology": "Secure Chip Technology",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.",
  "Cross-Platform Support": "Cross-Platform Support",
  "Works with various platforms for easy accessibility.":
    "Works with various platforms for easy accessibility.",
  AboutUsDescription1:
    "At LUKKEY, we are dedicated to providing top-quality solutions for managing your cryptocurrency assets securely.",
  AboutUsDescription2:
    "Our headquarters are in Zug, Switzerland. With a team of experienced professionals, we strive to innovate and adapt to the ever-changing landscape of the digital currency market.",
  BlockchainNetworksSupported: "Blockchain Networks Supported",
  CryptocurrenciesSupported: "Supporting Over 6,000 Cryptocurrencies",
  "home.warranty.years": "Years",
  "home.warranty.label": "Warranty",
  Years: "Years",
  ExpertiseInSecurity: "of Expertise in Security",
  FrequentlyAskedQuestions: "Frequently Asked Questions",
  WhatIsColdWallet: "What is a Cold Wallet?",
  ColdWalletDescription:
    "A cold wallet is a type of cryptocurrency wallet that stores your digital assets offline, making it less vulnerable to hacks and other online threats. Unlike hot wallets, which are connected to the internet and convenient for frequent transactions, cold wallets are best suited for long-term storage as they provide enhanced security.",
  HowToSetUpColdWallet: "How to Set Up Your Cold Wallet?",
  ColdWalletSetupDescription:
    "Setting up your cold wallet typically involves initializing the device on a secure, offline machine. You'll need to generate and securely store a recovery phrase, which is essential for accessing your assets in case of device loss or failure. Detailed instructions are provided with your purchase, ensuring a smooth setup process.",
  CryptocurrenciesCompatibleWithColdWallet:
    "Which cryptocurrencies are compatible with your cold wallets?",
  CryptocurrenciesCompatibilityDescription:
    "Our cold wallets support a wide range of cryptocurrencies, including major ones like Bitcoin, Ethereum, and Litecoin, as well as various altcoins. For a complete list of supported currencies, please visit our website or refer to the product documentation.",
  HowToSecureColdWallet: "How do I ensure my cold wallet is secure?",
  ColdWalletSecurityDescription:
    "To secure your cold wallet, always keep the recovery phrase in a safe and private location, never share it with anyone, and consider using additional security measures such as biometric locks or secure enclosures. Regularly updating the wallet's firmware from the official website also helps protect against vulnerabilities.",
  ColdWalletNotWorking:
    "What should I do if my cold wallet is not working or if I encounter an error?",
  ColdWalletErrorDescription:
    "If you experience any issues with your cold wallet, refer to the troubleshooting section of our user guide. For more specific problems, contact our support team through our website. Ensure you have your device information handy to expedite the support process.",
  Community: "Community",
  Settings: "Settings",
  "Wallet Management": "Wallet Management",
  "Auto-Lock": "Auto-Lock",
  "10 minutes": "10 minutes",
  Shutdown: "Shutdown",
  "Power off": "Power off",

  // Newsletter subscribe
  "Subscribe.title": "Get product updates",
  "Subscribe.subtitle":
    "We track crypto trends for you. Get product updates, market insights, and exclusive perks—delivered straight to your inbox.",
  "Subscribe.placeholder": "Enter your email",
  "Subscribe.button": "Get product updates",
  "Subscribe.input.aria": "Email address input",
  "Subscribe.success":
    "Thanks for subscribing! Please check your inbox for the confirmation email.",
  "Subscribe.error": "Subscription failed. Please try again later.",
  "Subscribe.invalid": "Please enter a valid email address.",
  "Subscribe.privacy":
    "Your email address will only be used to send our newsletter and updates. You can unsubscribe at any time using the link included in the newsletter.",
  "Subscribe.learnMore":
    "Learn more about how we manage your data and your rights.",
  "Subscribe.popupCompact.title": "Stay updated",
  "Subscribe.popupCompact.subtitle":
    "Product updates and security insights. No spam.",
  "Subscribe.popupCompact.button": "Subscribe",
  "Subscribe.popupCompact.privacy": "Email only. Unsubscribe anytime.",
  "SubscribeConfirmed.alt.success": "Subscription Confirmed",
  "SubscribeConfirmed.alt.failed": "Subscription Failed",
  "SubscribeConfirmed.title.success": "Subscription Confirmed",
  "SubscribeConfirmed.title.failed": "Subscription Failed",
  "SubscribeConfirmed.message.success":
    "Thank you for confirming your email. Your subscription is now active. A welcome email has been sent to your inbox.",
  "SubscribeConfirmed.message.failed":
    "The confirmation link is invalid or has expired. Please return to the homepage and try subscribing again.",
  "SubscribeConfirmed.cta.backHome": "Back to Home",
  "SubscribeConfirmed.note.unsubscribe":
    "You can unsubscribe anytime via the link in our emails.",
  // Lukkey page
  "lukkey.hero.title": "LUKKEY",
  "lukkey.hero.subtitle": "Your assets your control",
  "lukkey.hero.imageAlt": "Lukkey cold wallet hero product",
  "lukkey.physical.title": "Security, built in silicon.",
  "lukkey.physical.subtitle":
    "A hardware security architecture built on multiple secure elements, anchored by an EAL6+ root of trust and reinforced by tamper-resistant circuit and structural design.",
  "lukkey.physical.annotation.title": "Hardware root of trust.",
  "lukkey.physical.annotation.description":
    "Multiple secure elements, anchored by EAL6+ and reinforced by tamper-resistant circuit and structural design.",
  "lukkey.physical.cardTamper.title": "PCI-grade anti-tamper (potting + self-destruct)",
  "lukkey.physical.cardTamper.description":
    "Exploded-structure visualization with semi-transparent potting around the core chip, clearly layered but inaccessible.",
  "lukkey.physical.cardChip.title": "EAL6+ secure chip",
  "lukkey.physical.cardChip.description":
    "The chip floats in dark space while data beams are constrained by secure boundaries.",
  "lukkey.physical.explode.coreChip": "Core Chip",
  "lukkey.physical.explode.securityBoundary": "Security Boundary",
  "lukkey.physical.explode.pottingLayer": "Potting Layer",
  "lukkey.physical.explode.outerShell": "Outer Shell",
  "lukkey.design.title": "Design is not decoration, it is credibility",
  "lukkey.design.description":
    "Industrial design with iF and Red Dot-level craftsmanship, emphasizing chamfered edges and subtle glass reflections.",
  "lukkey.design.featureTitle": "Color touchscreen · card-sized form",
  "lukkey.design.featureDescription":
    "Compared 1:1 with a real bank card, highlighting the pocketable 9.6mm thickness.",
  "lukkey.design.thickness": "Thickness 9.6mm",
  "lukkey.design.closing":
    "Macro transitions and moving highlights still resolve into a refined full form.",
  "lukkey.reliability.title": "IP68 Waterproof\nIP6X Dustproof",
  "lukkey.reliability.description":
    "IP68-rated waterproofing and IP6X dustproof protection, built to block water and fine-particle intrusion in harsh environments.",
  "lukkey.reliability.canvasLine1": "IP68 Waterproof",
  "lukkey.reliability.canvasLine2": "IP6X Dustproof",
  "lukkey.reliability.bullet1": "Slow-motion water enveloping the device",
  "lukkey.reliability.bullet2": "High-speed droplets with zero ingress",
  "lukkey.reliability.bullet3": "Dust-proof, waterproof, and drop-resistant",
  "lukkey.reliability.imageAlt": "Lukkey IP68 waterproof showcase",
  "lukkey.system.title": "Safe Mode",
  "lukkey.system.description":
    "A discreet protection layer for sensitive situations.\n\nSafenotes disguises the wallet interface as a notes-style page,\nwhile only the active account remains visible.\nSensitive operations such as single-account deletion are restricted.",
  "lukkey.system.account.accountA": "Account A",
  "lukkey.system.account.hiddenWallet": "Hidden Wallet",
  "lukkey.system.account.decoyVault": "Decoy Vault",
  "lukkey.system.account.locked": "Locked",
  "lukkey.system.multiAccountTitle":
    "Support for 3 Independent Recovery Phrases",
  "lukkey.system.multiAccountDescription":
    "Create up to three completely independent wallets, each secured by its own recovery phrase. Separate assets, strategies, or identities while keeping full control of your digital assets.",
  "lukkey.system.layers.primary": "Primary",
  "lukkey.system.layers.vault": "Vault",
  "lukkey.system.layers.shadow": "Shadow",
  "lukkey.daily.title": "Fingerprint Unlock",
  "lukkey.daily.description":
    "Unlock your wallet instantly with fingerprint authentication.\n\nFast, seamless, and verified directly on the device.",
  "lukkey.capability.title": "NFT Support",
  "lukkey.capability.description":
    "A dark-space asset display bay with glassy cards and low saturation to emphasize ownership and control.",
  "lukkey.capability.nftItem": "NFT #{{index}}",
  "lukkey.backup.title": "NFC Backup Card",
  "lukkey.backup.description":
    "An NFC backup card with an EAL6+ secure element.\nSimply tap the device to securely back up or import recovery phrases.",
  "lukkey.backup.imageAlt": "NFC mnemonic backup demonstration",
  "lukkey.trust.title": "Open & Verifiable Security",
  "lukkey.trust.description":
    "Built on an EAL6+ secure element and an open-source architecture,\nLUKKEY allows both hardware and software security to be independently verified.\n\nKey generation, storage, and signing remain protected inside the device,\nwhile open-source code enables transparent security review by the community.\n\nSecurity you can verify. Control that remains yours.",
  "lukkey.video.title": "Built to Protect. Designed to Endure.",
  "lukkey.video.description":
    "Swiss-crafted and security-obsessed, LUKKEY is the cold wallet for those who demand total control.",
  "lukkey.values.privacy.title": "Privacy",
  "lukkey.values.privacy.description":
    "Your keys never leave the device. Air-gapped signing keeps sensitive operations fully offline.",
  "lukkey.values.inclusive.title": "Inclusive Design",
  "lukkey.values.inclusive.description":
    "Human-centered design, built to be clear for beginners and efficient for experts.",
  "lukkey.values.secure.title": "Secure",
  "lukkey.values.secure.description":
    "Hardware-backed protection with multi-layer safeguards against tampering, extraction, and spoofing.",
  "lukkey.values.environment.title": "Environment",
  "lukkey.values.environment.description":
    "Built for long-term use with durable materials, repair-minded structure, and reduced replacement waste.",
  "lukkey.contact.title": "Stay in touch",
  "lukkey.contact.announcements": "Announcements can be found in our blog.",
  "lukkey.contact.pressLabel": "Press contact:",
  "lukkey.modal.contentLabel": "Email confirmation",
  "lukkey.modal.title": "Confirm your email",
  "lukkey.modal.description1":
    "Please open the confirmation email sent to you and click the verification link. Please be sure to check your spam folder too.",
  "lukkey.modal.description2":
    "You will be able to unsubscribe at any time.",
  "lukkey.modal.close": "Close",

  // ===== Common =====
  "Common.language": "Language",

  // ===== PasswordProtectedRoute =====
  "PasswordProtected.title": "Please enter the password to access this page.",
  "PasswordProtected.placeholder": "Password",
  "PasswordProtected.signIn": "Sign In",
  "PasswordProtected.error": "Incorrect password, please try again.",
  "PasswordProtected.show": "Show password",
  "PasswordProtected.hide": "Hide password",

  // ===== AdminAuth (/admin/auth) =====
  "AdminAuth.checking": "Checking session...",
  "AdminAuth.header.title": "Auth Management Console",
  "AdminAuth.header.downloadUsers": "Download Users JSON",
  "AdminAuth.header.downloadWhitelist": "Download Whitelist JSON",
  "AdminAuth.header.logout": "Sign Out",
  "AdminAuth.users.title": "Users",
  "AdminAuth.whitelist.title": "Whitelist",
  "AdminAuth.common.refresh": "Refresh",
  "AdminAuth.loading": "Loading...",
  "AdminAuth.error.loadUsers": "Failed to load user directory",
  "AdminAuth.error.loadWhitelist": "Failed to load whitelist",
  "AdminAuth.error.notSuperadmin":
    "Superadmin whitelist access required. Please sign in with a superadmin email.",
  "AdminAuth.table.email": "Email",
  "AdminAuth.table.name": "Name",
  "AdminAuth.table.firstSeen": "First Seen",
  "AdminAuth.table.lastLogin": "Last Login",
  "AdminAuth.table.loginCount": "Login Count",
  "AdminAuth.table.addedAt": "Added At",
  "AdminAuth.table.level": "Level",
  "AdminAuth.table.actions": "Actions",
  "AdminAuth.noData": "No data",
  "AdminAuth.users.quickAdd": "Add to whitelist",
  "AdminAuth.users.quickAddBlacklist": "Add to blacklist",
  "AdminAuth.whitelist.add.placeholderEmail": "Email",
  "AdminAuth.whitelist.add.placeholderName": "Name (optional)",
  "AdminAuth.whitelist.add.submit": "Add to whitelist",
  "AdminAuth.whitelist.add.success": "Added to whitelist",
  "AdminAuth.whitelist.level.normal": "Normal",
  "AdminAuth.whitelist.level.developer": "Developer",
  "AdminAuth.whitelist.level.publisher": "Publish Admin",
  "AdminAuth.whitelist.level.superadmin": "Super Admin",
  "AdminAuth.whitelist.remove": "Remove",
  "AdminAuth.whitelist.remove.success": "Removed from whitelist",
  "AdminAuth.whitelist.empty": "Whitelist is empty",

  "AdminAuth.error.loadBlacklist": "Failed to load blacklist",
  "AdminAuth.header.downloadBlacklist": "Download Blacklist JSON",
  "AdminAuth.table.note": "Note",
  "AdminAuth.blacklist.title": "Blacklist",
  "AdminAuth.blacklist.add.placeholderEmail": "Email",
  "AdminAuth.blacklist.add.placeholderNote": "Note (optional)",
  "AdminAuth.blacklist.add.submit": "Add to blacklist",
  "AdminAuth.blacklist.add.success": "Added to blacklist",
  "AdminAuth.blacklist.remove": "Remove",
  "AdminAuth.blacklist.remove.success": "Removed from blacklist",
  "AdminAuth.blacklist.empty": "Blacklist is empty",

  "AdminAuth.message.addFailed": "Failed to add to whitelist",
  "AdminAuth.message.removeFailed": "Failed to remove from whitelist",
  "PrivacyPolicy.title": "LUKKEY Privacy Policy",
  "PrivacyPolicy.intro.p1":
    "At LUKKEY, we believe the safest form of privacy is the kind that always remains fully in the user’s own hands.",
  "PrivacyPolicy.intro.p2":
    "Therefore, whether you are using the LUKKEY cold wallet hardware or the accompanying LUKKEY mobile application (App), we strictly adhere to one unshakeable principle:",
  "PrivacyPolicy.intro.p3_strong":
    "Unless the user explicitly authorizes it, we do not collect, store, or upload any user information.",
  "PrivacyPolicy.intro.p3_tail":
    "All usage-related data is stored locally on the user’s device only and is never transmitted to LUKKEY or any server.",
  "PrivacyPolicy.intro.p4":
    "This Privacy Policy explains how we uphold this principle.",

  "PrivacyPolicy.s1.title": "1. Scope of Application",
  "PrivacyPolicy.s1.appliesTo": "This Privacy Policy applies to:",
  "PrivacyPolicy.s1.item.hardware": "LUKKEY cold wallet hardware",
  "PrivacyPolicy.s1.item.app": "LUKKEY mobile application (App)",
  "PrivacyPolicy.s1.principle":
    "Both follow the unified privacy principle of “zero collection, zero upload, local-only storage.”",

  "PrivacyPolicy.s2.title": "2. Information We Do NOT Collect",
  "PrivacyPolicy.s2.desc":
    "To protect your privacy, we explicitly commit to not collecting, uploading, or storing any user information, including but not limited to:",
  "PrivacyPolicy.s2.li.identity":
    "Identity information: name, phone number, email address, postal address",
  "PrivacyPolicy.s2.li.walletSensitive":
    "Sensitive wallet data: private keys, mnemonic phrases, keystore files, wallet passwords",
  "PrivacyPolicy.s2.li.blockchain":
    "Blockchain data: wallet addresses, transaction history, asset information",
  "PrivacyPolicy.s2.li.behavior":
    "Usage behavior: app logs, click records, behavioral analytics",
  "PrivacyPolicy.s2.li.technical":
    "Technical information: device identifiers, geolocation, IP address",
  "PrivacyPolicy.s2.inShort.title": "In short:",
  "PrivacyPolicy.s2.inShort.desc":
    "Everything you see in the hardware device and the App exists only on your device. LUKKEY cannot access it.",

  "PrivacyPolicy.s3.title":
    "3. Privacy & Security Design of the Hardware Cold Wallet",
  "PrivacyPolicy.s3.desc":
    "LUKKEY cold wallet provides a fully offline and secure environment for users. Key features include:",
  "PrivacyPolicy.s3.h1.title": "1. Military-grade secure hardware",
  "PrivacyPolicy.s3.h1.l1": "EAL6+ certified Secure Element",
  "PrivacyPolicy.s3.h1.l2": "Full hardware-level encrypted communication",
  "PrivacyPolicy.s3.h2.title": "2. Security functions",
  "PrivacyPolicy.s3.h2.l1": "Fingerprint authentication",
  "PrivacyPolicy.s3.h2.l2": "Privacy mode",
  "PrivacyPolicy.s3.h2.l3": "Multi-wallet isolated management",
  "PrivacyPolicy.s3.h3.title": "3. Complete isolation",
  "PrivacyPolicy.s3.h3.l1": "No Internet connectivity",
  "PrivacyPolicy.s3.h3.l2": "No data-line connectivity",
  "PrivacyPolicy.s3.h4.title": "4. Tamper-resistant self-destruct",
  "PrivacyPolicy.s3.h4.desc":
    "If the device is dismantled, damaged, or subject to abnormal intrusion, the Secure Element automatically destroys sensitive data to ensure private keys cannot be extracted.",
  "PrivacyPolicy.s3.h5.title":
    "5. Sensitive operations performed only inside the Secure Element",
  "PrivacyPolicy.s3.h5.l1": "Wallet creation",
  "PrivacyPolicy.s3.h5.l2": "Wallet import",
  "PrivacyPolicy.s3.h5.l3": "Transaction signing",
  "PrivacyPolicy.s3.h5.note":
    "All sensitive processes occur 100% inside the Secure Element, never exposed to any non-secure chip or storage area.",
  "PrivacyPolicy.s3.h6.title":
    "6. No sensitive data stored outside the Secure Element",
  "PrivacyPolicy.s3.h6.desc":
    "Non-secure storage areas on the device never store private keys, mnemonic phrases, or any sensitive information.",

  "PrivacyPolicy.s4.title": "4. Privacy & Security Design of the LUKKEY App",
  "PrivacyPolicy.s4.desc":
    "The LUKKEY App focuses solely on displaying information and providing notifications. It does not handle sensitive wallet data.",
  "PrivacyPolicy.s4.n1.title": "1. What the App does NOT do",
  "PrivacyPolicy.s4.n1.l1": "Does not generate blockchain wallets",
  "PrivacyPolicy.s4.n1.l2": "Does not import blockchain wallets",
  "PrivacyPolicy.s4.n1.l3": "Does not store private keys or mnemonic phrases",
  "PrivacyPolicy.s4.n1.l4": "Does not upload any user data",
  "PrivacyPolicy.s4.n1.l5":
    "Does not conduct behavioral analytics, advertising tracking, or data collection",
  "PrivacyPolicy.s4.n2.title": "2. What the App DOES do",
  "PrivacyPolicy.s4.n2.l1":
    "Displays publicly accessible information authorized by the hardware",
  "PrivacyPolicy.s4.n2.l2":
    "Provides a privacy settings panel explaining the purpose of each permission",
  "PrivacyPolicy.s4.n2.l3":
    "Gives users full control to enable/disable permissions at any time",
  "PrivacyPolicy.s4.n2.l4": "Offers sensitive-information masking",
  "PrivacyPolicy.s4.n2.l5": "Disables screenshot/recording in certain views",
  "PrivacyPolicy.s4.n2.l6":
    "Detects suspicious blockchain addresses via local matching",
  "PrivacyPolicy.s4.n2.l7":
    "Regularly updates dangerous URLs, contracts, and addresses",
  "PrivacyPolicy.s4.n2.l8": "Updates flow one-way from server → device only",
  "PrivacyPolicy.s4.n2.l9": "No user data is ever sent back during updates",
  "PrivacyPolicy.s4.n3.title": "3. Local storage",
  "PrivacyPolicy.s4.n3.p1":
    "The App only stores non-private data locally, such as UI preferences, language, and theme settings. This data:",
  "PrivacyPolicy.s4.n3.l1": "is not uploaded",
  "PrivacyPolicy.s4.n3.l2": "is not synced",
  "PrivacyPolicy.s4.n3.l3": "is not accessible to LUKKEY",

  "PrivacyPolicy.s5.title": "5. Data Transmission & Server Policy",
  "PrivacyPolicy.s5.l1": "LUKKEY servers store no user information",
  "PrivacyPolicy.s5.l2":
    "App–server communication is limited to database updates and version updates",
  "PrivacyPolicy.s5.l3":
    "No user information is transmitted during communication",
  "PrivacyPolicy.s5.l4":
    "Even in the event of a server breach, no user data could be exposed because we never obtain such data in the first place",

  "PrivacyPolicy.s6.title": "6. Open-Source Transparency",
  "PrivacyPolicy.s6.l1": "LUKKEY App source code is open-sourced",
  "PrivacyPolicy.s6.l2": "LUKKEY hardware embedded firmware is open-sourced",
  "PrivacyPolicy.s6.l3": "Fully available on GitHub for anyone to audit",
  "PrivacyPolicy.s6.p": "Transparency is part of security.",

  "PrivacyPolicy.s7.title": "7. Complete User Control",
  "PrivacyPolicy.s7.p":
    "Even though we do not collect user information, users retain full control over their devices:",
  "PrivacyPolicy.s7.l1": "You may disable App permissions at any time",
  "PrivacyPolicy.s7.l2": "You may delete the App to remove all local App data",
  "PrivacyPolicy.s7.l3":
    "You may reset the hardware device to permanently erase private keys and wallet data",
  "PrivacyPolicy.s7.p2":
    "LUKKEY does not and cannot intervene in these actions.",

  "PrivacyPolicy.s8.title": "8. Contact Us",
  "PrivacyPolicy.s8.p":
    "If you have any questions regarding this Privacy Policy, please contact us:",
  "PrivacyPolicy.s8.email": "Email: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "Address: LUKKEY Headquarters, Baarerstrasse 25, 6300 Zug, Switzerland",
  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "Checking...",
  "EmailOtp.title": "Restricted Access: Enter email to get a sign-in code",
  "EmailOtp.nameLabel": "Name",
  "EmailOtp.namePlaceholder": "Enter your name",
  "EmailOtp.emailLabel": "Email",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "Send Code",
  "EmailOtp.resendCode": "Resend Code",
  "EmailOtp.resendWithCountdown": "Resend ({{s}}s)",
  "EmailOtp.codeValidityHint":
    "The verification code is valid for about 10 minutes",
  "EmailOtp.codeLabel": "Email Verification Code",
  "EmailOtp.codePlaceholder": "Enter the code you received",
  "EmailOtp.signIn": "Sign In",
  "EmailOtp.message.codeSent":
    "Verification code sent, please check your inbox",
  "EmailOtp.message.devPrinted":
    "Development mode: the verification code was printed to the server console",
  "EmailOtp.error.nameRequired": "Please enter your name",
  "EmailOtp.error.invalidEmail": "Please enter a valid email address",
  "EmailOtp.error.sendFailed":
    "Failed to send verification code. Please try again later.",
  "EmailOtp.error.codeRequired": "Please enter the verification code",
  "EmailOtp.error.verificationFailed": "Verification failed",
  "EmailOtp.error.notWhitelisted":
    "This email is not on the whitelist. Please contact the administrator.",
  "EmailOtp.error.blacklisted": "This email is blocked from signing in.",
  "EmailOtp.error.rateLimited": "Too many requests. Please try again later.",
  "EmailOtp.error.serverError": "Server error",
  "EmailOtp.error.invalidOrExpired":
    "The verification code is invalid or expired.",
  "EmailOtp.error.expired": "The verification code has expired.",
  "EmailOtp.error.incorrect": "The verification code is incorrect.",
  // ===== Academy i18n =====
  "Academy.hero.alert":
    "Security Reminder: Always verify links and never share your recovery phrase.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "Academy",
  "Academy.hero.subtitle":
    "Practical guides on crypto security, self-custody and LUKKEY cold wallet usage.",
  "Academy.search.placeholder": "Search tutorials, best practices, and FAQs…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "ARTICLE",
  "Academy.list.title": "Latest Guides",
  "Academy.list.viewAll": "VIEW ALL",
  "Academy.list.empty": "No results. Try another keyword.",
  "Academy.image.placeholder": "IMG",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "Back to Academy",
  "AcademyArticle.notFound": "Article not found",
  "AcademyArticle.author": "Author",
  "AcademyArticle.unscheduled": "No scheduled publish time",
  "home.hero.reserveCtaLabel": "Get Early Access — $1",
  "home.hero.reserveCtaNote": "Fully refundable. No purchase commitment."
};
export default enTranslation;
